import { useEffect, useState } from "react";
import {
  ErrorNotification,
  SuccessNotification,
} from "../../tosterNotification/tosters";
import axios from "axios";
import API_URL from "../../config";
import { Linkedin } from "lucide-react";

export default function ApproveRecruiter() {
  const [allRecruiters, setAllRecruiter] = useState([]);
  // /admin_recruiter/all-recruiters

  const fetchAllRecruiters = async () => {
    try {
      const response = await axios.post(
        `${API_URL}/api/admin_recruiter/all-recruiters`,
      );
      if (response.data.success) {
        console.log("$data", { response });
        setAllRecruiter(response.data.data);
        SuccessNotification("data fetched");
      }
    } catch (error) {
      console.error({ error });
      ErrorNotification("Something went wrong");
    }
  };

  useEffect(() => {
    fetchAllRecruiters();
  }, []);

  async function handleDelete(recruitedId) {
    try {
      const response = await axios.post(
        `${API_URL}/api/admin_recruiter/delete`,
        {
          recruiter_id: recruitedId,
        },
      );
      if (response.data.success) {
        SuccessNotification("Recruiter profile is marked as deleted");
        setAllRecruiter((prev) =>
          prev.map((rec) =>
            rec._id === recruitedId ? { ...rec, is_deleted: true } : rec,
          ),
        );
      }
    } catch (error) {
      console.log("Something went wrong!");
      ErrorNotification("Something went wrong! Please try again");
    }
  }

  async function handleVerify(recruitedId) {
    try {
      const response = await axios.post(
        `${API_URL}/api/admin_recruiter/approve`,
        {
          recruiter_id: recruitedId,
        },
      );
      if (response.data.success) {
        SuccessNotification("Recruiter verified");
        setAllRecruiter((prev) =>
          prev.map((rec) =>
            rec._id === recruitedId ? { ...rec, is_verified: true } : rec,
          ),
        );
      }
    } catch (error) {
      console.error("Something went wrong!", error);
      ErrorNotification("Something went wrong! Please try again ");
    }
  }

  return (
    <>
      <div className="main-wrapper">
        <div className="pt-5">
          <div className="">
            <div className="">
              <div className="pt-5">
                <div className="row">
                  {allRecruiters.map((user) => (
                    <div
                      className="col-md-6 col-lg-6 col-xl-4 mb-4"
                      key={user.id}
                    >
                      <div className="card shadow-sm h-100">
                        <div
                          className="card-body p-4"
                          style={{
                            border: `solid 2px ${
                              user.is_deleted ? "red" : "#006600"
                            }`,
                            borderRadius: "10px",
                          }}
                        >
                          <div className="d-flex align-items-center mb-3">
                            {/* <img
                              src={`https://0.0.0.0:5000${user.headshot}`}
                              alt={user.name}
                              className="rounded-circle"
                              width="50"
                              height="50"
                            /> */}
                            <div className="ms-3 text-capitalize ">
                              <h6 className="mb-0 fw-semibold text-black">
                                {user.name}
                              </h6>
                              <small className="text-black">
                                {user.company_name}
                              </small>
                              <small className="text-black">
                                {user?.company_website}
                              </small>
                            </div>
                          </div>

                          <div className="mb-2">
                            <div className="d-flex align-items-center mb-2">
                              <i className="ti ti-mail text-black me-1"></i>
                              <span className="fs-5 text-black">
                                {user.work_email}
                              </span>
                            </div>
                            <div className="d-flex align-items-center mb-2">
                              <i className="ti ti-calendar text-black me-2"></i>
                              <span className="fs-5 text-black">
                                Joined: {user.createdAt.split("T")[0]}
                              </span>
                            </div>
                            <div className="d-flex align-items-center mb-2 gap-2">
                              <Linkedin color="black" size={16} />
                              <span className="fs-5 wrap-break-all text-black">
                                LinkedIn: {user.linkedin_profile}
                              </span>
                            </div>
                          </div>

                          <div className="d-flex justify-content-between mt-4">
                            {user.is_verified ? (
                              <>
                                <button
                                  className="btn btn-primary btn-sm"
                                  disabled={user.is_verified}
                                >
                                  <i className="fa fa-check-square me-1"></i>
                                  Verified
                                </button>
                              </>
                            ) : (
                              <>
                                <button
                                  className="btn btn-primary btn-sm"
                                  disabled={user.is_deleted || user.is_verified}
                                  onClick={() => {
                                    handleVerify(user._id);
                                  }}
                                >
                                  <i className="ti ti-check me-1"></i>Verify
                                </button>
                              </>
                            )}
                            <button
                              className="btn btn-outline-danger btn-sm"
                              disabled={user.is_deleted}
                              onClick={() => {
                                handleDelete(user._id);
                              }}
                            >
                              <i className="ti ti-trash me-1"></i>Delete
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
